import ReactDatePicker from "react-datepicker"; // Import the datepicker
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  label?: string;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
  value: Date;
  onChange: (date: Date | null) => void;
}

export const FormDatePicker = ({
  label,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  value,
  onChange,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      {label ? (
        <p
          className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
        >
          {label}
        </p>
      ) : null}
      <ReactDatePicker
        {...rest}
        selected={value}
        onChange={onChange}
        className={`w-full h-[46px] px-4 bg-sky-lighter border ${
          error ? "border-red-base" : "border-gray-border"
        } ${
          error ? "focus:border-red-base" : "focus:border-focused-border"
        } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
        placeholderText={placeholder}
        wrapperClassName="w-full"
      />
    </div>
  );
};
